module.exports = __webpack_public_path__ + "d43c5e22b4f2261584d5bcbb76794f3a.webp";